module.exports = function (data, rank = false) {
    if (data) {
        const keySorted = Object.keys(data).sort((a, b) => data[a] - data[b]).reverse();
        if (rank) return keySorted.slice(0, rank);
        return keySorted;
    }
    return data;
};
